export default {
  status: {
    draft: 'draft', // separate models on server but merged on frontend
    submitted: 'submitted',
    confirmed: 'confirmed',
    completed: 'completed',
    cancelled: 'cancelled'
  }
};
